import { isValidDate } from '../../../../util/guards';
import { renderModel } from '../../../util/renderModel';

interface IReturnedDate {
  iso?: string;
  a11y?: string;
}

export const useDate = (date: string | number): IReturnedDate => {
  const t = new Date(date);
  const locale = renderModel.getLocale();

  return isValidDate(t.toString())
    ? {
        iso: t.toISOString(),
        a11y: t.toLocaleDateString(locale, {
          year: 'numeric',
          month: 'long',
          day: 'numeric',
        }),
      }
    : {};
};
